{
  "login": "Вход",
  "algorithms": "Алгоритмы",
  "allowLegacy": "Разрешить устаревшие",
  "allowLegacyHint": "Нужны коммутаторам старше десяти лет. Включают SHA-1 и режим CBC — для остальных узлов это ослабление защиты без пользы.",
  "hostKeyNotPinned": "Ключ хоста ещё не закреплён — платформа запомнит его при первом подключении.",
  "hostKeyLabel": "Ключ хоста ({{type}}): ",
  "hostKeyTypeUnknown": "тип неизвестен",
  "hostKeyPinnedAt": "закреплён {{at}}",
  "noBanner": "сервер не представился",
  "accepts": "принимает: {{list}}",
  "noSftp": "без SFTP",
  "noOpenTerminals": "Открытых терминалов нет",
  "noOpenTerminalsHint": "Терминал открывается с карты сети или экрана узлов: выберите узел и нажмите «Терминал». К одной машине открывается одна вкладка.",
  "tabsOf": "{{open}} из {{max}}",
  "filesOnMachine": "Файлы на машине",
  "smaller": "Мельче",
  "bigger": "Крупнее",
  "copySelection": "Скопировать выделенное",
  "pasteFromClipboard": "Вставить из буфера обмена",
  "paste": "Вставить",
  "connectingTo": "Подключаемся к {{name}}…",
  "reconnect": "Переподключиться",
  "connectAgain": "Подключиться заново",
  "closedWithCode": "Соединение закрыто, код выхода {{code}}",
  "closedInTerminal": "соединение закрыто",
  "closedInTerminalWithCode": "соединение закрыто, код выхода {{code}}",
  "bannerHint": "Идентификация сервера",
  "routeHint": "Как дотянулись до машины",
  "kexHint": "Обмен ключами и шифр",
  "legacyAllowed": "разрешены устаревшие алгоритмы",
  "authMethod": {
    "password": "пароль",
    "key": "приватный ключ",
    "keyboardInteractive": "диалог с сервером (keyboard-interactive)"
  },
  "algorithmKind": {
    "keyExchange": "обмена ключами",
    "hostKey": "ключа хоста",
    "cipher": "шифрования",
    "mac": "проверки целостности (MAC)",
    "compression": "сжатия",
    "handshake": "рукопожатия"
  },
  "key": {
    "escape": "Escape",
    "tab": "Tab — дополнение",
    "ctrlC": "Ctrl+C — прервать",
    "ctrlD": "Ctrl+D — конец ввода",
    "ctrlZ": "Ctrl+Z — в фон",
    "up": "Предыдущая команда",
    "down": "Следующая команда",
    "left": "Влево",
    "right": "Вправо",
    "pipe": "Вертикальная черта",
    "slash": "Слэш",
    "tilde": "Тильда"
  },
  "hostKeyChanged": {
    "title": "Ключ хоста {{name}} изменился",
    "explanation": "Так выглядит и переустановка сервера, и подмена машины в сети. Пока причина не выяснена, платформа не подключается и пароль на этот сервер не отправляет. Если сервер недавно переустанавливали — подтвердите новый ключ; если нет — не подтверждайте и разберитесь, что стоит по этому адресу.",
    "was": "Было",
    "now": "Стало",
    "keyType": "Тип ключа",
    "checked": "Я проверил отпечаток на самой машине",
    "confirming": "Подтверждаем…",
    "trust": "Доверять новому ключу",
    "forbidden": "Подтвердить смену ключа вправе тот, кому доверены учётные данные. Обратитесь к администратору организации."
  }
}
